export default "__VITE_ASSET__Dixcm82K__"